/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import ConnectionRoom = Models.ConnectionRoom;
    import Block = Models.Block;
    import IBlock = Models.IBlock;
    import BlockConnections = Models.BlockConnections;
    import Pipe = Models.Pipe;
    
    /**
     * ConnectionRoom Controller class
     */
    export abstract class ConnectionRoomParentController {

        public selectedConnectionRoom: Models.IConnectionRoom;
        public matchedPipes: Models.IPipe[];        
        protected connectionRooms: ConnectionRoom[];
        protected cookieKey: string = 'flex_connectionroom_selectedroom';

        protected userCanWriteRoom: boolean;

        /**
         * Constructor
         */
        constructor(protected $scope: ng.IScope,
                    protected connectionRoomService: Services.ConnectionRoomService,
                    protected modalService: ngModal.IModalService,
                    protected qService: ng.IQService,
                    protected $cookies: ng.cookies.ICookiesService,
                    protected aclAservice: Services.AclService,
                    protected messageTranslationsService: Services.MessageTranslationsService,
                    callback?: () => void) {
            this.loadConnectionRooms().then(() => {
                if (callback !== undefined)
                    callback();
            });
        }

        /**
         * Modal to create a new connection room
         */
        public createCRModal(): void {
            let self: Controllers.ConnectionRoomParentController = this;

            this.modalService.showModal({
                templateUrl: Application.Controllers.GenericPromptModalController.templateUrl,
                controller: Application.Controllers.GenericPromptModalController.$name,
                inputs: {
                    title: 'New connection room',
                    description: '',
                    inputName: 'Name',
                    inputRequired: true,
                    inputValue: '',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.GenericPromptModalController.id,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: IGenericPromptModalResult) => {
                    modalElem.hide();
                    if (result) {
                        self.createConnectionRoom(result.answer);
                    }
                });
            });
        }
        
        /**
         * Modal to edit a connection room
         */
        public editCRModal(): void {
            let self: Controllers.ConnectionRoomParentController = this;

            this.modalService.showModal({
                templateUrl: Application.Controllers.GenericPromptModalController.templateUrl,
                controller: Application.Controllers.GenericPromptModalController.$name,
                inputs: {
                    title: 'Rename connection room',
                    description: '',
                    inputName: 'Name',
                    inputRequired: true,
                    inputValue: this.selectedConnectionRoom.name,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.GenericPromptModalController.id,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: IGenericPromptModalResult) => {
                    modalElem.hide();
                    if (result) {
                        self.editConnectionRoom(result.answer);
                    }
                });
            });
        }

        /**
         * Modal to delete the selected connection room
         */
        public deleteCRModal(): void {
            let self: Controllers.ConnectionRoomParentController = this;

            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE CONNECTION ROOM',
                    description: 'This action cannot be undone.',
                    name: this.selectedConnectionRoom.name,
                    type: 'warning',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: string) => {
                    modalElem.hide();
                    if (result) {
                        self.removeConnectionRoom();
                    }
                });
            });
        }

        public createConnectionRoom(name: string): void {
            let newConnectionRoom: ConnectionRoom = ConnectionRoom.Empty();
            newConnectionRoom.name = name;
            this.connectionRoomService.createConnectionRoom(newConnectionRoom)
                .then((element: Models.IConnectionRoom) => {
                    if (this.connectionRooms === undefined) {
                        this.connectionRooms = [element];
                        this.matchedPipes = element.pipes;
                    }
                    else {
                        this.connectionRooms.push(element);
                        this.selectedConnectionRoom = element;
                        this.matchedPipes = element.pipes;
                    }
                })
                .catch((reason: ngCustom.IReason) => {
                    this.loadConnectionRooms();
                    this.messageTranslationsService.showPromiseError(reason);
                });
        }

        public editConnectionRoom(name: string): void {
            this.selectedConnectionRoom.name = name;
            this.connectionRoomService
                .updateConnectionRoom(this.selectedConnectionRoom)
                .then((connRoom: ConnectionRoom) => {
                        for (let i: number = 0; i < this.connectionRooms.length; i++)
                            if (this.connectionRooms[i].href === connRoom.href)
                                this.connectionRooms[i].name = connRoom.name;
                }).catch((reason: ngCustom.IReason) => {
                    this.loadConnectionRooms();
                    this.messageTranslationsService.showPromiseError(reason);
                });
        }

        public saveSelectedConnectionRoom(): ng.IPromise<Models.IConnectionRoom> {
            return this.connectionRoomService
            .updateConnectionRoom(this.selectedConnectionRoom)
                .then((connRoom: ConnectionRoom) => {
                        for (let i: number = 0; i < this.connectionRooms.length; i++)
                            if (this.connectionRooms[i].href === connRoom.href) {
                                this.connectionRooms[i].name = connRoom.name;
                                this.connectionRooms[i].blockHrefs = connRoom.blockHrefs;
                                this.connectionRooms[i].pipes = connRoom.pipes;
                            }
                        this.selectedConnectionRoom = connRoom;
                        return connRoom;
                });
        }

        public removeConnectionRoom(): void {
            this.connectionRoomService
                .removeConnectionRoom(this.selectedConnectionRoom)
                .then(() => {
                    let indexToDelete: number = -1;
                    for (let i: number = 0; i < this.connectionRooms.length; i++)
                        if (this.connectionRooms[i].href === this.selectedConnectionRoom.href)
                            indexToDelete = i;
                    if (indexToDelete !== -1)
                       this.connectionRooms.splice(indexToDelete, 1);
                    
                    if (this.connectionRooms === undefined || this.connectionRooms.length === 0) {
                        this.selectedConnectionRoom = undefined;
                        this.matchedPipes = undefined;
                    } else {
                        this.selectedConnectionRoom = this.connectionRooms[0];
                        this.matchedPipes = this.connectionRooms[0].pipes;
                    }
                }).catch((reason: ngCustom.IReason) => {
                    this.loadConnectionRooms();
                    this.messageTranslationsService.showPromiseError(reason);
                });
        }

        public connRoomComparator(firstElement: Models.IConnectionRoom, secondElement:Models.IConnectionRoom): boolean {
            return firstElement && secondElement &&  firstElement.id==secondElement.id;
        }

        public createPipe(): void {
            this.createPipeWithNDestinations(1);
        }

        public savePipe(pipe: Models.IPipe): ng.IPromise<Models.IPipe> {
            pipe.connectionRoomHref = this.selectedConnectionRoom.href;
            return this.connectionRoomService.savePipe(pipe)
                .then((element: Models.IPipe) => {
                    this.updateSavedPipeInFrontendModel(element);
                    return element;
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                    return pipe;
                });
        }

        /**
         * Modal to search blocks
         */
        public searchBlockModal(direction: string): ng.IPromise<Block> {
            let deferred: ng.IDeferred<Block> = this.qService.defer();
            if (direction === 'INPUT') {
                this.connectionRoomService.findAvailableSources(this.searchBlocksModalCallback(direction, deferred));
            } else {
                this.connectionRoomService.findAvailableSinks(this.searchBlocksModalCallback(direction, deferred));
            }
            return deferred.promise;
        }

        protected searchBlocksModalCallback(direction: string, deferred: ng.IDeferred<Block>): (blocks: IBlock[]) => void {
            return (blocks: IBlock[]) => {
                this.modalService.showModal({
                    templateUrl: Application.Controllers.BlocksModalController.templateURL,
                    controller: Application.Controllers.BlocksModalController.$name,
                    inputs: {
                        type: direction === BlockConnections.DIRECTION_INPUT ? "source" : (direction === "BOTH" ? "both" : "sink"),
                        blocks: blocks,
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.BlocksModalController.ID,
                                                            {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((block: Block) => {
                        modalElem.hide();
                        if (block)
                            deferred.resolve(block);
                    });
                })
                .catch((reason: ngCustom.IReason) => {
                    deferred.reject(reason);
                });
            };
        };

        public disconnectDestination(pipe: Models.IPipe, index: number = pipe.disconnectedDestination): ng.IPromise<Models.IPipe> {
            return this.connectionRoomService.disconnectDestination(pipe, index)
                .then((element: Models.IPipe) => {
                    for (let i: number = 0; i < this.selectedConnectionRoom.pipes.length; i++)
                        if (this.selectedConnectionRoom.pipes[i].href === element.href)
                            this.selectedConnectionRoom.pipes[i] = element;
                    return element;
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                    return reason;
                });
        }
        
         public disconnectSource(pipe: Models.IPipe): ng.IPromise<Models.IPipe> {
            return this.connectionRoomService.disconnectSource(pipe)
                .then((element: Models.IPipe) => {
                    for (let i: number = 0; i < this.selectedConnectionRoom.pipes.length; i++)
                        if (this.selectedConnectionRoom.pipes[i].href === element.href)
                            this.selectedConnectionRoom.pipes[i] = element;
                    return element;
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                    return reason;
                });
        }

        public validateConnection(sourceBlockId: number, destinationBlockId: number): ng.IPromise<Models.IConnectionValidation> {
            return this.connectionRoomService.validateConnection(sourceBlockId, destinationBlockId)
                .then((connectionValidation: Models.IConnectionValidation) => {
                    return connectionValidation;
                });
        }


        /**
         * Modal to edit room permissions
         */
        public aclMRModal(): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.AclModalController.templateURL,
                controller: Application.Controllers.AclModalController.$name,
                inputs: {
                    entity: this.selectedConnectionRoom,
                    entityTypeName: 'connRooms',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.AclModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    modalElem.hide();
                });
            });
        }

        protected loadConnectionRooms(): ng.IPromise<ConnectionRoom> {
            return this.baseLoadConnectionRooms();
        }

        protected baseLoadConnectionRooms(): ng.IPromise<ConnectionRoom> {
            return this.connectionRoomService.getAllConnRoomsPromise().then((connRooms: ConnectionRoom[]) => {
                this.connectionRooms = Common.Utils.orderArrayByKey(connRooms, 'name');
                const selected: Models.ConnectionRoom = this.chooseSelectedRoom(connRooms);
                return this.connectionRoomService.fillPipes(selected).then((filledConnRoom: Models.ConnectionRoom) => {
                    return filledConnRoom;
                });
            });
        }

        protected checkUserCanWriteRoom( connRoom: ConnectionRoom ): void {
            this.aclAservice
                .canWrite("connRooms", Common.Utils.idFromHref(connRoom.href))
                .then((can: boolean) => {
                    this.userCanWriteRoom = can;
                });
        }

        protected chooseSelectedRoom(connRooms: ConnectionRoom[]): ConnectionRoom {
            if (connRooms.length > 0) {
                if (this.$cookies.get(this.cookieKey)) {
                    this.connectionRooms.forEach((connectionRoom: Models.IConnectionRoom) => {
                        if (parseInt(this.$cookies.get(this.cookieKey), 10) === Common.Utils.idFromHref(connectionRoom.href)) {
                            this.selectedConnectionRoom = connectionRoom;
                            this.matchedPipes = connectionRoom.pipes;
                        }
                    });
                }
                if (this.selectedConnectionRoom === undefined) {
                    this.selectedConnectionRoom = this.connectionRooms[0];
                    this.matchedPipes = this.connectionRooms[0].pipes;
                }
                return this.selectedConnectionRoom;
            }
        }

        protected createPipeWithNDestinations(numDestinations: number): ng.IPromise<Models.IPipe> {
            let pipe: Models.Pipe = Pipe.EmptyWith(numDestinations);
            pipe.name = "Pipe";
            pipe.href = '';
            pipe.connectionRoomHref = this.selectedConnectionRoom.href;
            pipe.numOrder = 1;
            if (this.selectedConnectionRoom.pipes !== undefined) {
                for (let i: number = 0; i < this.selectedConnectionRoom.pipes.length; i++) {
                    if (pipe.numOrder <= this.selectedConnectionRoom.pipes[i].numOrder)
                        pipe.numOrder = this.selectedConnectionRoom.pipes[i].numOrder;
                }
                pipe.numOrder++;
            }

            return this.connectionRoomService
                .savePipe(pipe)
                .then((element: Models.IPipe) => {
                    if (this.selectedConnectionRoom.pipes !== undefined)
                        this.selectedConnectionRoom.pipes.push(element);
                    else
                        this.selectedConnectionRoom.pipes = [element];
                    return element;
                })
                // tODO: Remove the selectedConnectionRoom model 'cause is causing wrong behaviours
                .finally(() => {
                    for (let i: number = 0; i < this.connectionRooms.length; i++)
                        if (this.connectionRooms[i].href === this.selectedConnectionRoom.href)
                            this.connectionRooms[i] = this.selectedConnectionRoom;
                });
        }

        protected removePipe(pipe: Models.IPipe): void {
            this.connectionRoomService.removePipe(pipe)
                .then(() => {
                    let indexToDelete: number = -1;
                    for (let i: number = 0; i < this.selectedConnectionRoom.pipes.length; i++) {
                        if (this.selectedConnectionRoom.pipes[i].href === pipe.href) {
                            indexToDelete = i;
                        }
                    }
                    if (indexToDelete !== -1) {
                        this.selectedConnectionRoom.pipes.splice(indexToDelete, 1);
                    }
                    
                    for (let i: number = 0; i < this.connectionRooms.length; i++) {
                        if (this.selectedConnectionRoom.href === this.connectionRooms[i].href) {
                            this.connectionRooms[i].pipes = this.selectedConnectionRoom.pipes;
                        }
                    }
                }).catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                    return reason;
                });
        }

        protected removePipePromise(pipe: Models.IPipe): ng.IPromise<ngCustom.IReason> {
            return this.connectionRoomService.removePipe(pipe)
                .then(() => {
                    let indexToDelete: number = -1;
                    for (let i: number = 0; i < this.selectedConnectionRoom.pipes.length; i++) {
                        if (this.selectedConnectionRoom.pipes[i].href === pipe.href) {
                            indexToDelete = i;
                        }
                    }
                    if (indexToDelete !== -1) {
                        this.selectedConnectionRoom.pipes.splice(indexToDelete, 1);
                    }
                    
                    for (let i: number = 0; i < this.connectionRooms.length; i++) {
                        if (this.selectedConnectionRoom.href === this.connectionRooms[i].href) {
                            this.connectionRooms[i].pipes = this.selectedConnectionRoom.pipes;
                        }
                    }
                }).catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                    return reason;
                });
        }

        protected updateSavedPipeInFrontendModel(element: Models.IPipe): void {
            for (let i: number = 0; i < this.selectedConnectionRoom.pipes.length; i++)
                if (this.selectedConnectionRoom.pipes[i].href === element.href)
                    this.selectedConnectionRoom.pipes[i] = element;
        }
    }
}
